import React from 'react';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
  onStepClick?: (step: number) => void;
}

const StepProgress: React.FC<StepProgressProps> = ({ currentStep, totalSteps, stepLabels, onStepClick }) => {
  const progressPercent = ((currentStep - 1) / totalSteps) * 100;

  return (
    <div style={{ marginBottom: '20px' }}>
      {/* Progress bar */}
      <div style={{ 
        height: '4px', 
        background: '#e5e7eb', 
        borderRadius: '2px', 
        marginBottom: '12px',
        overflow: 'hidden'
      }}>
        <div style={{ 
          height: '100%', 
          width: progressPercent + '%', 
          background: 'linear-gradient(90deg, #2a5298, #1e3c72)',
          borderRadius: '2px',
          transition: 'width 0.3s ease'
        }} />
      </div>
      
      {/* Step indicators */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        gap: '4px'
      }}>
        {stepLabels.map((label, index) => {
          const stepNum = index + 1;
          const isActive = currentStep === stepNum;
          const isCompleted = currentStep > stepNum;
          
          return (
            <div 
              key={index}
              onClick={() => onStepClick && isCompleted && onStepClick(stepNum)}
              style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                gap: '4px',
                flex: 1,
                cursor: isCompleted && onStepClick ? 'pointer' : 'default',
                opacity: isActive || isCompleted ? 1 : 0.5
              }}
            >
              <div style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                color: isActive || isCompleted ? 'white' : '#999',
                background: isCompleted ? '#10b981' : isActive ? '#2a5298' : '#e5e7eb',
                border: isActive ? '2px solid #1e3c72' : 'none',
                transition: 'all 0.3s ease'
              }}>
                {isCompleted ? '\u2713' : stepNum}
              </div>
              <span style={{ 
                fontSize: '10px', 
                color: isActive ? '#2a5298' : '#666',
                fontWeight: isActive ? 'bold' : 'normal',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%'
              }}>
                {label}
              </span>
            </div>
          );
        })}
      </div>
      
      {/* Step counter */}
      <div style={{ textAlign: 'center', marginTop: '8px', fontSize: '12px', color: '#999' }}>
        Step {currentStep} of {totalSteps}
      </div>
    </div>
  );
};

export default StepProgress;
